// extracted by mini-css-extract-plugin
export var animationContainer = "_ds-0";
export var asteriskIcon = "_ds-8";
export var conversationLeftSection = "_ds-4";
export var conversationListItem = "_ds-3";
export var conversationMiddleSection = "_ds-5";
export var conversationRightSection = "_ds-6";
export var detailsContent = "_ds-1";
export var listContainer = "_ds-7";
export var modalContent = "_ds-2";